<template>
  <section class="section pt-5">
    <customers-datatable />
  </section>
</template>

<script>
import CustomersDatatable from "./customers_datatable/Index.vue";

export default {
  name: "CustomertIndex",
  components: { CustomersDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
